import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetCriticalityWeightScurveGraph = (params: QueryParams, endpoint: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, (QueryKeys | QueryParams)[]>({
        queryKey: ['getProgressScurveGraph', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.actualMetaDataId && params.baselineMetaDataId && params.graphType),
    });
};

interface Data {
    text: string;
    label: number;
    value: number;
}

interface GraphLine {
    title: string | null;
    seriesname: null;
    data: Data[];
}

export interface QueryResponse {
    nowDate: string;
    plannedGraphLine: GraphLine;
    actualGraphLine: GraphLine;
    forecatsGraphLine: GraphLine;
    info: IToolTip;
}

export interface QueryParams extends NarrativeRequest {
    actualMetaDataId: number | undefined;
    baselineMetaDataId: number | undefined;
    graphType: string;
    isPartialCompletion: string;
    filter: {
        filters: IFilter[] | undefined;
    };
}
